import { AxiosError } from 'axios'
import { useEffect, useState } from 'react'
import { ZodError } from 'zod'

import Loader from '@/components/Atoms/Loader/Loader'
import TreeEntityCreationModal from '@/components/EntityCreationModals/TreeEntityCreationModal/TreeEntityCreationModal'
import TreeTiles from '@/components/TreeTiles/TreeTiles'
import { GENERAL_ERRORS_MESSAGES } from '@/constants'
import { nomenclatureGroupSchema } from '@/schemas'
import { useTreeTilesStore } from '@/stores/feed/treeTilesStore'
import api from '@/utils/api/api'
import getGeneralErrorMessage from '@/utils/api/errors/getGeneralErrorMessage'
import { cleanCategoryTree } from '@/utils/catalog/cleanDescription'

import cn from './NomenclatureGroupsCatalog.module.scss'

function NomenclatureGroupsCatalog() {
  const [open, setOpen] = useState<boolean>(false)
  const [loadingError, setLoadingError] = useState<string>('')
  const [loading, setLoading] = useState<boolean>(false)
  const [isTreeReady, setIsTreeReady] = useState<boolean>(false) // ✅ НОВОЕ!

  const { nomenclatureGroupsTree: tree, setNomenclatureGroupsTree: setTree } =
    useTreeTilesStore((state) => state)

  useEffect(() => {
    if (!tree.length) {
      setLoading(true)
      setLoadingError('')
      setIsTreeReady(false)

      api
        .get('/main/nomenclature-groups/root-trees')
        .then((response) => {
          const treeData = response.data.trees || response.data
          const validatedNomenclatureGroups = nomenclatureGroupSchema
            .array()
            .parse(treeData)
          const cleanedData = cleanCategoryTree(validatedNomenclatureGroups)
          setTree(cleanedData)
        })
        .catch((error) => {
          console.error('Error fetching nomenclature groups tree:', error)
          if (error instanceof AxiosError) {
            setLoadingError(getGeneralErrorMessage(error))
          } else if (error instanceof ZodError) {
            setLoadingError(GENERAL_ERRORS_MESSAGES.ZOD_ERROR)
          } else {
            setLoadingError(GENERAL_ERRORS_MESSAGES.DEFAULT_ERROR)
          }
        })
        .finally(() => {
          setLoading(false)
          setIsTreeReady(true) // ✅ Дерево готово!
        })
    } else {
      // ✅ ДАННЫЕ УЖЕ ЕСТЬ — ждем обработки TreeTiles
      setIsTreeReady(false)
      setTimeout(() => setIsTreeReady(true), 100) // Минимальная задержка
    }
  }, [tree.length, setTree]) // ✅ Срабатывает при переходе!

  return (
    <section className={cn.nomenclatureGroupsCatalog}>
      <TreeEntityCreationModal
        open={open}
        setOpen={setOpen}
        externalTree={tree}
        setExternalTree={setTree}
        treeType="nomenclature-groups"
      />

      {/* ✅ ЛОАДЕР ВСЕГДА при переходе */}
      {(loading || !isTreeReady) && (
        <Loader loaderType="modal" isModalOpen={true} />
      )}

      {!loading && !loadingError && isTreeReady && (
        <div className={cn.inner}>
          <span className={cn.title}>Каталог по номенклатурным группам</span>
          <TreeTiles
            tree={tree}
            treeLoading={false}
            loadingError={loadingError}
            setTree={setTree}
            actionButton={
              <button className={cn.actionButton} onClick={() => setOpen(true)}>
                Добавить номенклатурную группу
              </button>
            }
          />
        </div>
      )}

      {!loading && loadingError && (
        <div className={cn.inner}>
          <p className={cn.errorMessage}>{loadingError}</p>
        </div>
      )}
    </section>
  )
}

export default NomenclatureGroupsCatalog
